(() => {
  document.querySelectorAll('[data-values-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-values-track]');
    const cards = [...carousel.querySelectorAll('.rdr21-values__card')];
    if (!track || cards.length < 2) return;

    const scrollByCard = (direction) => {
      const card = cards[0];
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      track.scrollBy({
        left: direction * (card.getBoundingClientRect().width + gap),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    };

    carousel.querySelector('[data-values-previous]')?.addEventListener('click', () => scrollByCard(-1));
    carousel.querySelector('[data-values-next]')?.addEventListener('click', () => scrollByCard(1));
  });
})();
